import { CloseOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

/**
 * Shared button to open cancel supervision modal. Used by BookedButtons and WaitingBookingButtons.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {Function} props.setCancelSupervisionModalVisible - Function to set the visibility of the cancel supervision modal.
 * @returns {JSX.Element} The CancelSupervisionButton component.
 */
export const CancelSupervisionButton = ({
  setCancelSupervisionModalVisible
}) => {
  const { t } = useTranslation();
  return (
    <Button
      type="primary"
      style={{ backgroundColor: 'red' }}
      onClick={() => setCancelSupervisionModalVisible(true)}
    >
      <CloseOutlined />
      {`${t('supervisions.show.buttons.cancel_supervision')} `}
    </Button>
  );
};

CancelSupervisionButton.propTypes = {
  setCancelSupervisionModalVisible: PropTypes.func.isRequired
};
